import type { Entities } from "../types"

export const entities: Entities = new Map([
  [
    "mev-capital",
    {
      name: "MEV Capital",
      logo: "entities/mev-capital.svg",
      description:
        "MEV Capital is a digital asset manager that focuses on finding and extracting value from the nascent DeFi markets. The strategies are conducted following a stable asset exposure mandate supported by well-defined benchmarks. The operations mainly consist of risk curations and liquidity provisioning to a set of public protocols. These protocols are selected to reflect internal risk management rules, fit regulatory criteria, and answer investor needs. MEV Capital aims to achieve consistent returns for the investors, while operating in a highly liquid environment and battle-tested security framework.",
      url: "https://mevcapital.com/",
      addresses: {
        "0xB672Ea44A1EC692A9Baf851dC90a1Ee3DB25F1C4": "MEV Capital Multisig",
      },
      social: { twitter: "mevcapital" },
    },
  ],
  [
    "tulipa-capital",
    {
      name: "Tulipa Capital",
      logo: "entities/tulipacapital.png",
      description:
        "At Tulipa Capital, we leverage cutting-edge technology and innovative financial strategies to maximize yields while implementing rigorous risk management practices.",
      url: "https://www.tulipa.capital/",
      addresses: {
        "0xF53eAeB7e6f15CBb6dB990eaf2A26702e1D986d8": "Tulipa Capital Multisig",
      },
      social: { twitter: "tulipacapital" },
    },
  ],
  [
    "re7-labs",
    {
      name: "Re7 Labs",
      logo: "entities/re7labs.png",
      description:
        "Re7 Labs is the innovation arm of digital asset investment firm Re7 Capital, taking the practical experience of DeFi risk management to on-chain vaults.",
      url: "https://www.re7labs.xyz/",
      addresses: {
        "0x3BA1566ED39F865bAf4c1Eb9acE53F3D2062bE65":
          "Re7 Labs Euler Berachain Multisig",
      },
      social: { twitter: "Re7Labs" },
    },
  ],
  [
    "zerolend",
    {
      name: "ZeroLend",
      logo: "entities/zerolend.jpg",
      description:
        "ZeroLend is a decentralized lending market curating vaults for LRTs, Real World Assets (RWAs), BTCFi, and promising tokens.",
      url: "https://zerolend.xyz/",
      addresses: {
        "0x1f906603A027E686b43Fab7f395C11228EbE8ff4": "ZeroLend Multisig",
      },
      social: { twitter: "zerolendxyz" },
    },
  ],
])
